<template>
  <div class="dropdown netpa-list-page-filter-dropdown">
    <button
      class="btn netpa-list-page-filter-btn"
      type="button"
      :id="buttonId"
      data-toggle="dropdown"
      aria-expanded="false"
      dir="rtl"
    >
      <span class="netpa-list-page-filter-btn__label">
        <i
          class="fas fa-filter netpa-list-page-filter-btn__icon"
          aria-hidden="true"
        ></i>
        {{ label }}
      </span>
      <i
        class="fas fa-chevron-down netpa-list-page-filter-btn__caret"
        aria-hidden="true"
      ></i>
    </button>
    <div
      class="dropdown-menu netpa-list-page-filter-menu"
      :aria-labelledby="buttonId"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "NetPaFilterDropdown",
  props: {
    label: {
      type: String,
      required: true,
    },
    buttonId: {
      type: String,
      required: true,
    },
  },
};
</script>
